const prefix = 'fasr';
const iconName = 'percent';
const width = 384;
const height = 512;
const aliases = [62101, 62785, 'percentage'];
const unicode = '25';
const svgPathData = 'M369 113l17-17L352 62.1 335 79 15 399l-17 17L32 449.9l17-17L369 113zM16 80v96h96V80H16zM272 336v96h96V336H272z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
